import axios from 'axios'
const client = axios.create({baseURL:`${window.location.origin}/admin-session`, withCredentials:true, timeout:25000})
export const accessToken = () => sessionStorage.getItem('accessToken')
export function clearLogin() {
 sessionStorage.removeItem('accessToken'); localStorage.removeItem('accessToken'); localStorage.removeItem('refreshToken'); localStorage.removeItem('userData')
}
export function saveLogin(r) {
 if (!r.accessToken || !r.userInfo) throw Error('로그인 응답을 확인해 주세요.')
 sessionStorage.setItem('accessToken', r.accessToken)
 localStorage.removeItem('accessToken'); localStorage.removeItem('refreshToken')
 const profile = {...r.userInfo, ability:[{action:'manage', subject:'all'}]}
 localStorage.setItem('userData', JSON.stringify(profile))
 window.dispatchEvent(new CustomEvent('admin-session-update', {detail:profile.session || {}}))
 return profile
}
export function safeReturnPath(value) {
 try {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\r\n]/.test(value)) return null
  const url = new URL(value, window.location.origin)
  if (url.origin !== window.location.origin || !url.pathname.startsWith('/moaland/') || url.pathname.startsWith('/moaland/auth/')) return null
  return url.pathname + url.search + url.hash
 } catch { return null }
}
export function rememberReturnPath() {
 const path = safeReturnPath(window.location.pathname + window.location.search + window.location.hash)
 if (path) sessionStorage.setItem('admin-return-to', path)
}
export function loginDestination() {
 const path = safeReturnPath(new URLSearchParams(window.location.search).get('returnTo')) || safeReturnPath(sessionStorage.getItem('admin-return-to'))
 sessionStorage.removeItem('admin-return-to')
 return path || '/moaland/manage/campaign'
}
export function afterLoginPath(profile) {
 const destination = loginDestination()
 if (profile.mustChangePassword) {
  sessionStorage.setItem('admin-return-to', destination)
  return '/moaland/auth/password'
 }
 return destination
}
let running = Promise.resolve(), refreshPromise
async function exclusive(fn) {
 if (navigator.locks?.request) return navigator.locks.request('kviewo-admin-session', fn)
 const result = running.then(fn, fn); running = result.catch(() => {}); return result
}
export async function sessionAction(action, data = {}) {
 return exclusive(async () => {
  let response
  for (let i = 0; i < 2; i++) {
   try { response = await client.post(`/${action}`, data); break } catch (e) {
    if (e.response?.status !== 409 || i) throw e
    await new Promise(resolve => setTimeout(resolve, 250))
   }
  }
  const r = response.data
  if (r.success === false) throw Error(r.error?.msg || '요청을 처리하지 못했습니다.')
  if (r.accessToken) saveLogin(r)
  return r
 })
}
export function refreshAccess() {
 if (!refreshPromise) refreshPromise = sessionAction('refresh').finally(() => { refreshPromise = null })
 return refreshPromise
}
export async function logoutAdmin() {
 try { await sessionAction('logout') } catch (e) { if (e.response?.status !== 401) throw e }
 clearLogin(); window.location.assign('/moaland/auth/intro')
}
let contactPromise
export function confirmContactAccess() {
 if (!contactPromise) contactPromise = new Promise((resolve, reject) => window.dispatchEvent(new CustomEvent('admin-confirm-contact', {detail:{resolve, reject}}))).finally(() => { contactPromise = null })
 return contactPromise
}
